import type { Question } from "@shared/schema";

// Read-only student-style render of a test. Used on the preview page so a
// teacher can see what was finalized at a glance. No edit affordances, no
// Socrates badges, no per-question toolbars — just directions on top, then
// numbered stems and A/B/C/D choices.

interface StudentCopyRenderProps {
  name: string;
  directions?: string | null;
  questions: Question[];
}

const answerLabel = (index: number): string => String.fromCharCode(65 + index);
const DEFAULT_DIRECTIONS = "Please read each question carefully and select the best answer.";

export function StudentCopyRender({ name, directions, questions }: StudentCopyRenderProps) {
  return (
    <article className="bg-white border rounded-lg p-6 sm:p-8 text-foreground">
      <h2 className="text-2xl font-bold text-center mb-1">{name}</h2>
      <p className="text-sm text-muted-foreground italic mb-6 text-center">
        {directions || DEFAULT_DIRECTIONS}
      </p>
      <ol className="space-y-5 list-decimal list-inside">
        {questions.map((q) => (
          <li key={q.id} className="leading-relaxed">
            <span className="font-medium">{q.stem}</span>
            <ol className="mt-2 ml-6 space-y-1">
              {q.answers.map((answer, ansIdx) => (
                <li key={ansIdx} className="text-sm flex gap-2">
                  <span className="text-muted-foreground shrink-0">{answerLabel(ansIdx)})</span>
                  <span>{answer}</span>
                </li>
              ))}
            </ol>
          </li>
        ))}
      </ol>
    </article>
  );
}
